var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:_vm.game.status},[_vm._v(" "+_vm._s(_vm.formatStatus(_vm.game))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }